import { clsx } from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { colorClasses } from '../../lib/colors';

export type BadgeProps = {
  /** A `COLOR_TOKENS` value (from meta: stage/tier/tag colors). Unknown tokens render slate. */
  color?: string;
  /** soft (default): tinted; solid: filled — reserve for the highest-signal state (e.g. hot tier). */
  variant?: 'soft' | 'solid';
  /** Leading colored dot. */
  dot?: boolean;
  icon?: LucideIcon;
  size?: 'sm' | 'md';
  title?: string;
  className?: string;
  children: ReactNode;
};

export function Badge({ color = 'slate', variant = 'soft', dot, icon: Icon, size = 'sm', title, className, children }: BadgeProps) {
  const classes = colorClasses(color);
  return (
    <span
      title={title}
      className={clsx(
        'inline-flex max-w-full shrink-0 items-center gap-1 rounded-md border font-medium whitespace-nowrap',
        size === 'sm' ? 'h-5 px-1.5 text-2xs' : 'h-6 px-2 text-xs',
        variant === 'solid' ? classes.solid : classes.badge,
        className,
      )}
    >
      {dot && <span aria-hidden className={clsx('size-1.5 shrink-0 rounded-full', variant === 'solid' ? 'bg-white/80' : classes.dot)} />}
      {Icon && <Icon size={size === 'sm' ? 11 : 12} aria-hidden className="shrink-0" />}
      <span className="truncate">{children}</span>
    </span>
  );
}
